import { LitElement, intlTelInput, html } from '@hh/global.js'

class HHCustomForm extends LitElement {
  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()
    this.intTelInputs = {}
    this.form = this.querySelector('form')
    this.phoneInputs = this.querySelectorAll('.js-phone-input')
    this.successBanner = this.querySelector('.js-success-banner')
    this.errorBanner = this.querySelector('.js-error-banner')

    this.phoneInputs.forEach(input => {
      this.intTelInputs[input.id] = intlTelInput(input, {
        initialCountry: window.Shopify.country,
        nationalMode: true,
        loadUtilsOnInit: "https://cdn.jsdelivr.net/npm/intl-tel-input@24.7.0/build/js/utils.js",
      });
    })

    this.form.addEventListener('submit', this.onSubmit.bind(this))
    this.validateStatus()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  validateStatus() {
    const urlParams = new URLSearchParams(window.location.search)
    
    if (urlParams.get('origin') === 'custom-form' && urlParams.get('ometria_form_ok') === 'Y') {
      this.showSuccess()
      window.location.href = '#CustomForm'
      window.history.pushState({}, null, `${window.location.origin}${window.location.pathname}`)
    } else if (urlParams.get('origin') === 'custom-form' && urlParams.get('ometria_form_ok') === 'N') {
      this.showError()
      window.location.href = '#CustomForm'
      window.history.pushState({}, null, `${window.location.origin}${window.location.pathname}`)
    }
  }

  onInput(e) {
    const { name, value, id, type } = e.target

    this.querySelectorAll(`[data-sync-with="${name}"]`)
      .forEach(field => {
        field.value = value
      })

    if (type === 'tel') {
      const phoneInput = this.intTelInputs[id]

      if (phoneInput.isValidNumber()) {
        this.querySelector(`[name="${(name || '').replace('-phone', '')}"]`).value = phoneInput.getNumber()
      }
    }
  }

  onSubmit(e) {
    e.preventDefault()
    this.hideStatus()

    let invalid = false

    Object.keys(this.intTelInputs).forEach(key => {
      if(!!this.intTelInputs[key].telInput.value || this.intTelInputs[key].telInput.required) {
        if (!!this.intTelInputs[key].telInput.value && this.intTelInputs[key].isValidNumber()) {
          this.intTelInputs[key].telInput.classList.remove('is-invalid')
        } else {
          this.intTelInputs[key].telInput.classList.add('is-invalid')
          invalid = true
        }
      } else {
        this.intTelInputs[key].telInput.classList.remove('is-invalid')
      }
    })

    if (invalid) return

    this.form.submit()
  }

  showSuccess() {
    this.successBanner?.removeAttribute('hidden')
  }

  showError() {
    this.errorBanner?.removeAttribute('hidden')
  }

  hideStatus() {
    this.successBanner?.setAttribute('hidden', true)
    this.errorBanner?.setAttribute('hidden', true)
  }

  render() {
    return html`<slot
      @input="${this.onInput}"
    ></slot>`
  }
}

customElements.define('hh-custom-form', HHCustomForm)
